import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';

import { selectAuth } from 'src/app/state/auth.selectors';
import { PostLoginService } from '../post-login.service';
import { AuthenticationService } from '../authentication.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  token: string;

  constructor(
    private store: Store,
    private postLoginService: PostLoginService,
    private authenticationService: AuthenticationService
  ) {
    this.store.pipe(select(selectAuth))
      .subscribe(auth => {
        this.token = auth?.access_token;
      });
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const excludedEndPoints = ['/token', '/countries', '/regions', '/CountriesWithActiveTestCentres', '/TransferRegions'];
    const skipAuth = excludedEndPoints.some(x => req.url.endsWith(x));
    if (!skipAuth) {
      let authorization = '';
      if (this.token) {
        authorization = 'Bearer ' + this.token;
      }
      const headers = new HttpHeaders({
        Authorization: authorization
      });
      const newRequest = req.clone({
        headers,
        withCredentials: true
      });
      return next.handle(newRequest).pipe(tap(() => { },
        err => {
          if (err instanceof HttpErrorResponse) {
            if (err.status !== 401) {
              return;
            }
            this.authenticationService.logout();
            this.postLoginService.showLoginRedirect();
          }
        }));
    }
    return next.handle(req);
  }

}
